module.exports = __webpack_public_path__ + "static/media/Frame1.38039cd1.png";